import { SITE, NAV_LINKS } from "../config";
import { scrollToSection } from "./Nav";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-heading text-3xl font-semibold tracking-[0.12em] text-ink">
              {SITE.name}<span className="text-accent">.</span>
            </p>
            <p className="mt-2 text-xs uppercase tracking-[0.22em] font-bold text-stone">{SITE.title}</p>
            <p className="mt-4 font-heading italic text-xl text-ink/70">
              "Custom websites, built for your business."
            </p>
          </div>

          <nav aria-label="Footer" className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-stone mb-4">Navigate</p>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(l.href); }}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-base text-ink/80 hover:text-accent transition-colors duration-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-stone mb-4">Elsewhere</p>
            <ul className="space-y-2.5">
              <li><a data-testid="footer-social-whatsapp" href={SITE.whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-base text-ink/80 hover:text-accent transition-colors duration-300">WhatsApp</a></li>
              <li><a data-testid="footer-social-email" href={`mailto:${SITE.email}`} className="text-base text-ink/80 hover:text-accent transition-colors duration-300">{SITE.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-line flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-stone">© 2026 {SITE.fullName}. All rights reserved.</p>
          <p className="text-xs uppercase tracking-[0.2em] text-stone/70">Designed & built by {SITE.fullName.split(" ")[0]}</p>
        </div>
      </div>
    </footer>
  );
}
